const SEARCH_TRIGGER_DATA_ATTRIBUTE = 'data-gb-search-trigger';
const TASK_LINK_DATA_ATTRIBUTE = 'data-gb-task-link';
const TASK_DESCRIPTION_EDITOR_BODY_CLASS = 'task-description-editor';

export {
    SEARCH_TRIGGER_DATA_ATTRIBUTE,
    TASK_LINK_DATA_ATTRIBUTE,
    TASK_DESCRIPTION_EDITOR_BODY_CLASS,
};
